<template>
  <div class="cdn-table">
    <table border="0" align="center" width="100%" cellpadding="0" cellspacing="0">
      <tbody>
         <tr height="51" class="tr-warp-head">
          <td width="90%">
            <div class="checked-row">
              <CDNCheckbox
                :checkedImg="require('@/assets/images/domain/icon_checkbox_selected.png')"
                :unCheckedImg="require('@/assets/images/domain/icon_checkbox_noselect.png')"
                :checkedStatus="allSelect"
                @selectedCheck="headerAllCheck"
              />
              <span>菜单名称</span>
            </div>
          </td>
          <td><span>操作</span></td>
        </tr>
        <template v-for="(item, index) in tableData">
          <tr
           height="51"
            class="tr-warp"
            :key="index"
            >

          <td width="90%">
            <div class="first-row">
               <div class="checked-row">
            <CDNCheckbox
                :checkedImg="require('@/assets/images/domain/icon_checkbox_selected.png')"
                :unCheckedImg="require('@/assets/images/domain/icon_checkbox_noselect.png')"
                :checkedStatus="allSelect"
                @selectedCheck="headerAllCheck"
              />
            {{ item.name }}
            </div>

            <div class="first-end-row">
              <div class="delete-tc">删除套餐</div>
              <div class="super-user">超级管理员</div>
              <div class="yunwei">运维</div>
            </div>
            </div>
          </td>
          <td>
             <div class="user-handle">
              <img src="@/assets/images/products/icon_edit.png" alt="">
              <img src="@/assets/images/domain/icon_delete.png" alt="">
            </div>
          </td>
        </tr>

        <!--  -->
        <tr
         height="51"
         class="tr-child-warp"
         v-for="(childItem, childIndex) in (item.children || [])"
         :key="childIndex"
        >
        <td width="80%">

         <div class="first-row">
          <div class="checked-row">
            <CDNCheckbox
                :checkedImg="require('@/assets/images/domain/icon_checkbox_selected.png')"
                :unCheckedImg="require('@/assets/images/domain/icon_checkbox_noselect.png')"
                :checkedStatus="allSelect"
                @selectedCheck="headerAllCheck"
              />
          {{ childItem.name }}
          </div>

            <div class="first-end-row">
              <div class="delete-tc">删除套餐</div>
              <div class="super-user">超级管理员</div>
              <div class="yunwei">运维</div>
            </div>
            </div>
          </td>
        <td>
          <div class="user-handle">
           <img src="@/assets/images/products/icon_edit.png" alt="">
           <img src="@/assets/images/domain/icon_delete.png" alt="">
          </div>
        </td>
          </tr>
        <!--  -->
        </template>

      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allSelect: false,
    };
  },
  methods: {
    headerAllCheck() {},
  },
};
</script>
<style lang="scss" scoped>
table{
border-collapse: collapse;
}
  .tr-warp-head {
    border-bottom: 3px solid #D7DBEC;
  }
  .tr-warp {
    border-bottom: 1px solid #D7DBEC;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #131523;
  }
  .tr-child-warp {
    border-left: 50px solid white;
    border-bottom: 1px solid #D7DBEC;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #5A607F;
    letter-spacing: 0;
  }
  .checked-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #131523;
    }

.first-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
     .user-handle {
      display: flex;
      align-items: center;
      :first-child {
        margin-right: 10px;
        width: 14px;
        height: 14px;
      }
      :last-child {
        width: 16px;
        height: 17px;
      }
    }
   .first-end-row {
     display: flex;
     align-items: center;
     margin-right: 15px;
     .delete-tc {
       border: 1px solid #D7DBEC;
       border-radius: 4px;
       width: 78px;
       height: 24px;
       line-height: 24px;
       text-align: center;
       font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      margin-right: 24px;
     }
     .super-user {
      background: #F99600;
      border-radius: 4px;
      width: 95px;
      height: 24px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 24px;
      text-align: center;
      margin-right: 20px;
     }
     .yunwei {
       background: #5A607F;
       border-radius: 4px;
       width: 52px;
       height: 24px;
       line-height: 24px;
       text-align: center;
       font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #FFFFFF;
     }
   }
</style>
